export interface PurchaseOrderVatAnalysis {
  header: string;
  nettValue: number;
  taxRate: number;
  vat: number;
  overallValue: number;
  nettValueString: string;
  taxRateString: string;
  vatString: string;
  overallValueString: string;
  currencySymbol: string;
}
